import React, { useEffect, useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  Alert,
} from "react-native";

import { StackActions } from "@react-navigation/native";
import BackgroundAdmin from "../components/BackgroundAdmin";
import Title from "../components/Title";
import Logo from "../components/Logo";
import InputLayout from "../components/InputLayoutAdmin";
import ButtonLayout from "../components/ButtonLayout";
import ButtonLayoutMenu from "../components/ButtonLayoutMenu";
import makeRequest from "../components/makeRequest";

export default function (props) {
  const [autocancelacion, setAutocancelacion] = useState(
    props.route.params.instalaciones.tiempoAutoCancelacion
  );
  const [aforoMaximo, setAforoMaximo] = useState(
    props.route.params.instalaciones.aforoMaximo
  );
  const [antelacion, setAntelacion] = useState(
    props.route.params.instalaciones.antelacion
  );
  const [maximoCitasPorUsuario, setMaximoCitasPorUsuario] = useState(
    props.route.params.instalaciones.maximoCitasPorUsuario
  );
  const [duracionCita, setDuracionCita] = useState(
    props.route.params.instalaciones.duracionCita
  );
  const [maximaDuracionCita, setMaximaduracionCita] = useState(
    props.route.params.instalaciones.maximaDuracionCita
  );
  const [maximoPersonas, setMaximoPersonas] = useState(
    props.route.params.instalaciones.maximoPersonas
  );
  const [failed, setFailed] = useState(false);
  const [failedText, setFailedText] = useState(false);
  const [nombre, setNombre] = useState(props.route.params.instalaciones.nombre);
  const [recordatorioFinal, setRecordatorioFinal] = useState(
    props.route.params.instalaciones.recordatorioFinal
  );
  const [recordatorioInicial, setRecordatorioInicial] = useState(
    props.route.params.instalaciones.recordatorioInicial
  );
  const editar = () => {
    Alert.alert(
      "¿Seguro que quiere modificar los datos de esta instalación? ",
      "Deberá crear periodos nuevos para aplicar los cambios",
      [
        {
          text: "Modificar",
          onPress: () => {
            if (aforoMaximo < 1) {
              setFailed(true);
              setFailedText("El aforo mínimo permitido es 1");
              return;
            }
            if (aforoMaximo > 99999) {
              setFailed(true);
              setFailedText("Aforo máximo alcanzado");
              return;
            }
            if (
              maximaDuracionCita % duracionCita != 0 ||
              duracionCita < 0 ||
              maximaDuracionCita < 0
            ) {
              setFailed(true);
              setFailedText("Parámetros de duración de la cita incorrectos");
              return;
            }
            if (maximoPersonas < 0 || maximoPersonas > 100) {
              setFailed(true);
              setFailedText("Máximo de personas no permitido");
              return;
            }
            if (antelacion < 1) {
              setFailed(true);
              setFailedText("Tiempo de antelación no permitido");
              return;
            }
            if (autocancelacion > maximaDuracionCita) {
              setFailed(true);
              setFailedText("Tiempo de autocancelación no permitido");
              return;
            }

            modificar();
          },
        },
        { text: "Cancelar", onPress: () => {} },
      ],
      { cancelable: true }
    );
    const modificar = async () => {
      const response = await makeRequest(
        "instalaciones/" + props.route.params.instalaciones._id,
        "put",
        {
          nombre: nombre,
          aforoMaximo: aforoMaximo,
          antelacion: antelacion,
          maximoCitasPorUsuario: maximoCitasPorUsuario,
          duracionCita: duracionCita,
          maximoPersonas: maximoPersonas,
          recordatorioFinal: recordatorioFinal,
          recordatorioInicial: recordatorioInicial,
          maximaDuracionCita: maximaDuracionCita,
          tiempoAutoCancelacion: autocancelacion,
        }
      );
      props.navigation.navigate("AdminScreen", {
        ...props.route.params,
        reload: true,
      });
    };
  };

  return (
    <BackgroundAdmin scroll={true}>
      <Logo navigation={props.navigation}></Logo>

      <Title style={{ fontSize: 16, fontWeight: "bold" }}>
        Disponibilidad y aforo para: {nombre}
      </Title>
      <View>
        <Title
          style={{
            color: "#4C686F",
            fontSize: 16,
            fontWeight: "bold",
            marginLeft: 40,
            marginRight: 40,
            textAlign: "left",
          }}>
          Número de usuarios máximos a la vez <Text>(aforo)</Text>
        </Title>
        <InputLayout
          value={"" + aforoMaximo}
          onChangeText={(text) => setAforoMaximo(parseInt(text) || 0)}
          style={{ maxWidth: 150, textAlign: "center" }}
          keyboardType='numeric'></InputLayout>
        <Title
          style={{
            color: "#4C686F",
            fontSize: 16,
            fontWeight: "bold",
            marginLeft: 40,
            marginRight: 40,
            textAlign: "left",
          }}>
          Tiempo de intervalo entre citas{" "}
        </Title>
        <InputLayout
          value={"" + duracionCita}
          onChangeText={(text) => setDuracionCita(parseInt(text) || 0)}
          style={{ maxWidth: 150 }}
          keyboardType='numeric'></InputLayout>
        <Title
          style={{
            color: "#4C686F",
            fontSize: 16,
            fontWeight: "bold",
            marginLeft: 40,
            marginRight: 40,
            textAlign: "left",
          }}>
          Tiempo máximo en minutos de duración de la cita (Debe ser un múltiplo
          del intervalo entre citas)
        </Title>
        <InputLayout
          value={"" + maximaDuracionCita}
          onChangeText={(text) => setMaximaduracionCita(parseInt(text) || 0)}
          style={{ maxWidth: 150 }}
          keyboardType='numeric'></InputLayout>
        <Title style={{ fontSize: 16, fontWeight: "bold" }}>
          Límites por usuario
        </Title>
        <Title
          style={{
            color: "#4C686F",
            fontSize: 16,
            fontWeight: "bold",
            marginLeft: 40,
            marginRight: 40,
            textAlign: "left",
          }}>
          Número máximo de citas por usuario{" "}
          <Text>(Cuántas citas pueden tener reservadas a la vez)</Text>
        </Title>
        <InputLayout
          value={"" + maximoCitasPorUsuario}
          onChangeText={(text) => setMaximoCitasPorUsuario(parseInt(text || 0))}
          style={{ maxWidth: 150 }}
          keyboardType='numeric'></InputLayout>
        <Title
          style={{
            color: "#4C686F",
            fontSize: 16,
            fontWeight: "bold",
            marginLeft: 40,
            marginRight: 40,
            textAlign: "left",
          }}>
          Número máximo de personas por cita
        </Title>
        <InputLayout
          value={"" + maximoPersonas}
          onChangeText={(text) => setMaximoPersonas(parseInt(text) || 0)}
          style={{ maxWidth: 150 }}
          keyboardType='numeric'></InputLayout>
        <Title
          style={{
            color: "#4C686F",
            fontSize: 16,
            fontWeight: "bold",
            marginLeft: 40,
            marginRight: 40,
            textAlign: "left",
          }}>
          Tiempo máximo de antelación con el que se puede hacer una cita{" "}
          <Text>(en días)</Text>
        </Title>
        <InputLayout
          value={"" + antelacion}
          onChangeText={(text) => setAntelacion(parseInt(text) || 0)}
          style={{ maxWidth: 150 }}
          keyboardType='numeric'></InputLayout>
        <Title
          style={{
            color: "#4C686F",
            fontSize: 16,
            fontWeight: "bold",
            marginLeft: 40,
            marginRight: 40,
            textAlign: "left",
          }}>
          Tiempo máximo de autocancelación si la cita no se acepta{" "}
          <Text>(en minutos)</Text>
        </Title>
        <InputLayout
          value={"" + autocancelacion}
          onChangeText={(text) => setAutocancelacion(parseInt(text) || 0)}
          style={{ maxWidth: 150 }}
          keyboardType='numeric'></InputLayout>
        <Title style={{ fontSize: 16, fontWeight: "bold" }}>
          Establecer notificaciones
        </Title>
        <Title
          style={{
            color: "#4C686F",
            fontSize: 16,
            fontWeight: "bold",
            marginLeft: 40,
            marginRight: 40,
            textAlign: "left",
          }}>
          Tiempo de anticipación a la notificación de inicio de cita (en
          minutos)
        </Title>
        <InputLayout
          value={"" + recordatorioInicial}
          onChangeText={(text) => setRecordatorioInicial(parseInt(text) || 0)}
          style={{ maxWidth: 150 }}
          keyboardType='numeric'></InputLayout>
        <Title
          style={{
            color: "#4C686F",
            fontSize: 16,
            fontWeight: "bold",
            marginLeft: 40,
            marginRight: 40,
            textAlign: "left",
          }}>
          Tiempo de anticipación a la notificación de fin de cita (en minutos)
        </Title>

        <InputLayout
          value={"" + recordatorioFinal}
          onChangeText={(text) => setRecordatorioFinal(parseInt(text) || 0)}
          style={{ maxWidth: 150, textAlign: "center" }}
          keyboardType='numeric'></InputLayout>
        <Title
          style={{
            color: "red",
            fontSize: 13,
            fontWeight: "bold",
            marginLeft: 40,
            marginRight: 40,
            textAlign: "center",
          }}>
          {failedText}
        </Title>
        <ButtonLayout
          style={{ maxWidth: 220 }}
          onPress={() => editar()}
          text='Confirmar cambios'
        />
        <ButtonLayoutMenu
          style={{ maxWidth: 150 }}
          prop
          text='Cancelar'
          onPress={() => props.navigation.popToTop()}
        />
      </View>
      <View style={{ height: 50 }}></View>
    </BackgroundAdmin>
  );
}
